// extracted by mini-css-extract-plugin
export default {"howItWorksItem":"HowItWorksItem_howItWorksItem__XR3N3","howItWorksItem__image":"HowItWorksItem_howItWorksItem__image__f3GeX"};